import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "list-loading h-100"
}

import i18n from '@/lang/i18n';
import RegisterModal from "@/components/Common/RegisterModal.vue";
import { Ref, ref, computed, reactive, nextTick, watch } from 'vue';
import DeliveryPlan from "@/types/DeliveryPlan";
import UnexpectedEventRegisterContent from "@/components/DailyReportUpdateModalParts/UnexpectedEventRegisterContent.vue"
import { ObjectToFormData, formatDateTime, firstFile } from '@/services/functions';
import Api from "@/services/api/ApiServiceFabrick";
import { scrollToErrorComponent } from '@/services/validators';
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue";
import getUnexpectedEvent from "@/types/responses/getUnexpectedEvent";
import UnexpectedEventFileType from '@/types/UnexpectedEventFile'

type errorTYpe = {
  'start_time': string[],
  'end_time': string[],
  'address': string[],
  'note': string[],
  'files.0': string[]
  'files.1': string[]
  'files.2': string[]
  'files.3': string[]
  'files.4': string[]
}

type flashMessagesType = {
  message: string,
  show: boolean,
  type: string,
  cancel: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UnexpectedEventRegisterModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    deliveryPlan: {},
    unexpectedEvent: {},
    isUnexpectedEventLoading: { type: Boolean, default: false },
    getUnexpectedEventAndLongTimeDrivingExtensions: {},
    createAuthority: { type: Boolean, default: true },
    updateAuthority: { type: Boolean, default: true },
    showFlash: {}
  },
  emits: ['update:modelValue', 'cancel', 'openModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const errors = ref({} as errorTYpe)
const isLoading: Ref<boolean> = ref(false)
const isFileLoading: Ref<boolean> = ref(false)
const registeredFiles = ref([] as UnexpectedEventFileType[])
const deleteFiles = ref([] as { id: number, file_path: string }[])
const id: Ref<number | string> = ref('')
const isDownloadings: Ref<boolean[]> = ref([false])

const flashMessage = reactive({
  message: "",
  show: false,
  type: "info",
  cancel: false
}) as flashMessagesType

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const isDisplayConservationButton = computed(() => {
  if (props.unexpectedEvent.id) return props.updateAuthority
  return props.createAuthority
})

let form = reactive({
  delivery_plan_id: props.deliveryPlan.delivery_plan_id ?? '',
  start_time: props.deliveryPlan.leaving_warehouse_date_time ?? new Date(),
  end_time: props.deliveryPlan.returning_warehouse_date_time ?? new Date(),
  address: '',
  note: '',
  files: [
    []
  ]
})

function createOrUpdate() {
  isLoading.value = true
  defaultErrors()
  const requestParams = makeRequestParams()
  Api().createOrUpdateUnexpectedEvent(requestParams, id.value).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.success'), true, "info", true)
    closeModal(true)
  }).catch((error) => {
      isLoading.value = false
      const res = error.response;
      switch (res.status) {
        case 403:
          location.reload();
          break;
        case 422:
          errors.value = res.data.errors;
          scrollToErrorComponent();
          break;
      }
  })
}

function makeRequestParams() {
  let requestParams = JSON.parse(JSON.stringify(form));
  requestParams.start_time = formatDateTime(new Date(requestParams.start_time))
  requestParams.end_time = formatDateTime(new Date(requestParams.end_time))
  requestParams.delete_files = deleteFiles.value

  let formData = new FormData()
  form.files.forEach((file: File | File[] | null, index: number) => {
    const selected = firstFile(file)
    if (!selected) return
    formData.append(`files[${index}]`, selected)
  })
  ObjectToFormData(requestParams, formData, '')
  return formData
}

function defaultErrors() {
  errors.value.start_time = []
  errors.value.end_time = []
  errors.value.address = []
  errors.value.note = []
  for (let i = 0; i < 5; i++) {
    errors.value[`files.${i}`] = []
  }
}

function changeFlashMessages(resultStatus = "", message = "") {
  flashMessage.type = resultStatus
  flashMessage.message = message
  flashMessage.show = true
  scrollTop()
}

function closeModal(isCreatedOrUpdated: boolean) {
  if (isCreatedOrUpdated && props.getUnexpectedEventAndLongTimeDrivingExtensions) props.getUnexpectedEventAndLongTimeDrivingExtensions()
  modelValue.value = false
  defaultErrors()
}

function scrollTop() {
  nextTick(() => {
    const scrollPoint = document.getElementById('flash-message-component')
    scrollPoint?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  })
}

function makeForm() {
  id.value = props.unexpectedEvent.id
  form.delivery_plan_id = props.unexpectedEvent.delivery_plan_id
  form.start_time = props.unexpectedEvent.start_time
  form.end_time = props.unexpectedEvent.end_time
  form.address = props.unexpectedEvent.address
  form.note = props.unexpectedEvent.note
  if (props.unexpectedEvent.files?.length) addFiles()
}

function addFiles() {
  isFileLoading.value = true
  for (let i = 0; i < props.unexpectedEvent.files.length; i++) {
    const file = props.unexpectedEvent.files[i];
    Api().getFileUrl("delivery_plan_unexpected_events", file.id).then((data) => {
      registeredFiles.value.push({
        id: props.unexpectedEvent.files[i].id,
        fileBlob: data,
        originalFileName: file.original_file_name,
      })
      registeredFiles.value = sortFiles(registeredFiles.value)
      if (i === props.unexpectedEvent.files.length - 1) isFileLoading.value = false
    }).catch((error) => {
      if (i === props.unexpectedEvent.files.length - 1) isFileLoading.value = false
      const res = error.response;
      switch (res.status) {
        case 404:
          deleteFiles.value.push({
            id: props.unexpectedEvent.files[i].id,
            file_path: props.unexpectedEvent.files[i].file_path
          })
          break
        case 403:
          location.reload();
          break;
      }
    })
  }
}

function sortFiles(registeredFiles: UnexpectedEventFileType[]) {
  return registeredFiles.sort(function(a, b) {
    return (a.id < b.id) ? -1 : 1;
  });
}

function deleteRegisteredFile(index: number, file: UnexpectedEventFileType) {
  deleteFiles.value.push({
    id: file.id,
    file_path: file.fileBlob
  })
  registeredFiles.value.splice(index, 1)
}

function downloadFile(fileId: number, index: number) {
  isDownloadings.value[index] = true
  const requestFile = makeRequest(fileId)
  Api().unexpectedEventFileDownload(requestFile.file_path).then((result: boolean) => {
    isDownloadings.value[index] = false
  }).catch((error) => {
    isDownloadings.value[index] = false
    const res = error.response;
    switch (res.status) {
      case 404:
        changeFlashMessages("error", i18n.global.t('pages.unexpectedEventAndAlertStatuses.fileDownload.notExistsFilePath'))
        break;
      case 403:
        location.reload();
        break;
    }
  })
}

function makeRequest(fileId: number) {
  return props.unexpectedEvent.files.find((unexpectedFile: any) => {
    return fileId == unexpectedFile.id
  })
}

watch(props, () => {
  if (props.unexpectedEvent) makeForm()
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue).value = $event)),
    modalMaxWidth: "45%",
    title: props.title
  }, {
    "flash-message": _withCtx(() => [
      _createVNode(ModalFlashMessage, {
        id: "flash-message-component",
        message: flashMessage.message,
        show: flashMessage.show,
        type: flashMessage.type,
        cancel: flashMessage.cancel,
        onSetShow: _cache[0] || (_cache[0] = (show) => {flashMessage.show = show})
      }, null, 8, ["message", "show", "type", "cancel"])
    ]),
    content: _withCtx(() => [
      (props.isUnexpectedEventLoading || isFileLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(UnexpectedEventRegisterContent, {
        modelValue: _unref(form),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(form) ? (form).value = $event : form = $event)),
        class: "mt-5",
        registeredFiles: registeredFiles.value,
        deleteRegisteredFile: deleteRegisteredFile,
        downloadFile: downloadFile,
        isDownloadings: isDownloadings.value,
        errors: errors.value
      }, null, 8, ["modelValue", "registeredFiles", "isDownloadings", "errors"])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (closeModal(false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
        ]),
        _: 1
      }),
      (isDisplayConservationButton.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "ma-2 exec-btn",
            loading: isLoading.value,
            onClick: createOrUpdate
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})